import { Typography, Button, Box, Grid, Container } from "@mui/material";
export const TelegramPage = () => {
  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "500px", sm: "400px", md: "250px" }, // Responsive height
          backgroundImage: "url('/caldea.jpg')", // Replace with your image URL
          background: "linear-gradient(to right bottom, #31438b, #61378e)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          objectPosition: "center bottom", // ⬅️ try 'center top', 'center center', or 'center bottom'
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent black shadow
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              padding: "16px",
              paddingTop: { xs: "60px", sm: "80px", md: "100px" }, // Increased padding for more space
              borderRadius: "8px",
            }}
          >
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              Benvinguts al nostre canal de Telegram
            </Typography>
          </Box>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        sx={{
          mt: "64px",
        }}
      >
        <Grid container spacing={2} sx={{ width: 1 }}>
          <Grid size={{ xs: 6, md: 8 }} offset={{ md: 2 }}>
            {/* <Typography variant="h4" gutterBottom>
              Explica’ns què busques i t’ho trobem.
            </Typography> */}
            {/* <iframe
              src="https://tally.so/embed/3xzADJ?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="1809"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Busco pis a Andorra"
            ></iframe> */}
            <Box textAlign="center" mb={6} mt={12}>
              <Typography variant="h4" sx={{ mb: 3 }}>
                Vols veure els pisos més interessants que trobem?
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Publiquem immobles que realment valen la pena. Sense spam.
              </Typography>

              <Button
                variant="contained"
                size="large"
                sx={{
                  background: "linear-gradient(to right, #36EAEF, #6B0AC9)",
                  backgroundSize: "200% auto",
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundPosition: "right center",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                  },
                  "&:active": {
                    background: "linear-gradient(to right, #4A0A9C, #2CA3B8)",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                  },
                  "&:focus": {
                    outline: "none",
                    boxShadow: "0 0 0 4px rgba(107, 10, 201, 0.4)",
                  },
                }}
              >
                Unir-me al canal de Telegram
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
